import styled from 'styled-components'

const ProviderMap = styled.div`
  width: 100%;
  height: 240px;
`

export default ProviderMap
